import { Backdrop, Box, Button, CircularProgress, Icon } from "@mui/material";
import { PageWithFilter } from "../../../../components/exports";
import MapFilter from "../../components/MapFilter";
import MapTutorial from "../../components/MapToturial";
import { MapState } from "../../slice/MapSlice";

type TProps = {
    mapContainer: React.MutableRefObject<any>;
    openFilterDialog: () => void;
    mapState: MapState;
};

export default function ProjectMapView({
    mapContainer,
    mapState,
    openFilterDialog,
}: TProps) {
    return (
        <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }}>
            <Box
                sx={{ width: "100%", height: "100%" }}
                ref={mapContainer}
                className="map-container"
            />

            <Button
                variant="contained"
                color="primary"
                onClick={openFilterDialog}
                startIcon={<Icon>filter_alt</Icon>}
                sx={{
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    zIndex: 1,
                    display: { xs: "flex", lg: "none" },
                }}
            >
                مشاهده فیلتر ها
            </Button>

            <Box
                sx={{
                    position: "fixed",
                    top: 80,
                    right: 16,
                    zIndex: 0,
                }}
            >
                <MapTutorial />
            </Box>

            <Box sx={{ mx: 2 }}>
                <PageWithFilter filter={<MapFilter />}></PageWithFilter>
            </Box>

            <Backdrop open={mapState.isLoading}>
                <CircularProgress sx={{ color: "white", zIndex: 2 }} />
            </Backdrop>
        </Box>
    );
}
